import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// La configuración se sigue obteniendo de las variables de entorno, como debe ser.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// 1. Inicializamos la aplicación de Firebase
const app = initializeApp(firebaseConfig);

// 2. Obtenemos y exportamos los servicios que necesitamos
export const database = getDatabase(app);
export const auth = getAuth(app);

// NOTA: Hemos quitado temporalmente la inicialización de encriptación, etc.,
// para aislar el problema y enfocarnos en dejar el dashboard 100% funcional.